import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetPlaceRequestFilterSensitiveLog, GetPlaceResponseFilterSensitiveLog, } from "../models/models_0";
import { de_GetPlaceCommand, se_GetPlaceCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class GetPlaceCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("LocationService", "GetPlace", {})
    .n("LocationClient", "GetPlaceCommand")
    .f(GetPlaceRequestFilterSensitiveLog, GetPlaceResponseFilterSensitiveLog)
    .ser(se_GetPlaceCommand)
    .de(de_GetPlaceCommand)
    .build() {
}
